require.context('../images', true);

import 'styles/application/index.scss';
import 'scripts/application/index.js';
